import { TagIcon as PhosphorTagIcon } from "@phosphor-icons/react/dist/ssr/Tag";

import { createAppIcon } from "@/components/createAppIcon";

export const OfferIcon = /* @__PURE__ */ createAppIcon(PhosphorTagIcon);
export const TagIcon = /* @__PURE__ */ createAppIcon(PhosphorTagIcon);
